import { lensPath, view } from 'rambda';

export type HighlightResult = {
  value: string;
  isHighlighted: boolean;
};

function parseHighlightedAttribute({ preTag, postTag, highlightedValue = '' }: any): HighlightResult[] {
  const splitByPreTag = highlightedValue.split(preTag);
  const firstValue = splitByPreTag.shift();
  const elements = firstValue === '' ? [] : [{ value: firstValue, isHighlighted: false }];

  splitByPreTag.forEach((split: any) => {
    const splitByPostTag = split.split(postTag);

    elements.push({
      value: splitByPostTag[0],
      isHighlighted: true,
    });

    if (splitByPostTag[1] !== '') {
      elements.push({
        value: splitByPostTag[1],
        isHighlighted: false,
      });
    }
  });

  return elements;
}

export function parseAlgoliaHit({
  preTag = '<em>',
  postTag = '</em>',
  highlightProperty = '_highlightResult',
  attribute,
  hit,
}: any): HighlightResult[] {
  if (!hit) {
    return [];
  }

  const highlightObject = (view(lensPath([highlightProperty, attribute]), hit) as any) ?? {};

  return parseHighlightedAttribute({
    preTag,
    postTag,
    highlightedValue: highlightObject.value,
  });
}
